<br />
<div class="govuk-width-container">
    <div class="govuk-grid-column">

        <div *ngIf="!this.rout.url.includes('/account')" class="govuk-grid-column govuk-heading-s">
            <a> Welcome {{member?.name}}</a>
            <div class="pull-right text-right"><a class="link" (click)="signOut()"> Sign Out</a></div>
        </div>

    </div>

</div>